import Modal from 'components/Modal';
import Typography from 'components/Typography';
import styles from './AddShopifyStoreModal.module.scss';
import FormGroup from 'components/FormGroup';
import TextField from 'components/TextField';
import {Controller, get, SubmitHandler, useForm} from 'react-hook-form';
import FormActionGroup from 'components/FormActionGroup';
import Button from 'components/Button';
import ReactSwitch from 'react-switch';
import api from 'api';
import useAuth from 'hooks/useAuth';
import toast from 'react-hot-toast';
import {encode} from 'js-base64';
import {useMutation} from 'react-query';

type AddShopifyStoreModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  refetch: () => void;
};

type AddShopifyStoreForm = {
  store_name: string;
  access_token: string;
  is_active: boolean;
};
const addShopifyStore = async (
  data: AddShopifyStoreForm & {company_id: number}
) => {
  return await api.post('/integrations/integration-configs/', {
    company: data.company_id,
    integration_type: 'shopify',
    credentials: {
      SHOPIFY_ACCESS_TOKEN: encode(data.access_token),
      SHOPIFY_STORE_NAME: encode(data.store_name),
    },
    is_active: data.is_active,
  });
};

function AddShopifyStoreModal({
  isOpen,
  handleClose,
  refetch,
}: AddShopifyStoreModalProps) {
  const {currentUser} = useAuth();
  const {
    register,
    control,
    handleSubmit,
    formState: {errors},
  } = useForm<AddShopifyStoreForm>();
  const {mutateAsync: addShopifyStoreMutation, isLoading} = useMutation({
    mutationFn: addShopifyStore,
    mutationKey: ['add-shopify-store'],
    onSuccess: refetch,
  });

  const handleSubmitAddStore: SubmitHandler<AddShopifyStoreForm> = async (
    data
  ) => {
    try {
      await addShopifyStoreMutation({
        ...data,
        company_id: Number(currentUser?.company?.id),
      });
      handleClose();
      toast.success('Shopify integration added successfully');
    } catch (error) {
      console.error(error);
      const message = get(
        error,
        'response.data.error_message',
        'Failed to add Shopify integration'
      );
      toast.error(message);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      className={styles.list_wrapper}
    >
      <div className={styles.list_innerContainer}>
        <Typography variant="h2">Add New Shopify Integration</Typography>
      </div>
      <FormGroup columns={1}>
        <TextField
          label="Store Name"
          placeholder="Enter Store Name"
          {...register('store_name', {required: 'Required'})}
          error={errors.store_name?.message as string}
        />
      </FormGroup>
      <FormGroup columns={1}>
        <TextField
          label="Shopify access token"
          placeholder="Enter access token"
          {...register('access_token', {
            required: 'Required',
          })}
          error={errors.access_token?.message as string}
        />
      </FormGroup>
      <FormGroup columns={1}>
        <Controller
          name="is_active"
          control={control}
          render={({field}) => (
            <div className={styles.switchContainer}>
              <span>Active:</span>
              <label>
                <ReactSwitch
                  onColor="#4286f4"
                  onChange={field.onChange}
                  handleDiameter={17}
                  height={20}
                  width={40}
                  className={styles.switch}
                  checked={field?.value ?? false}
                />
              </label>
            </div>
          )}
        />
      </FormGroup>

      <FormActionGroup className={styles.buttonWrap}>
        <Button
          onClick={handleSubmit(handleSubmitAddStore)}
          disabled={isLoading}
          loading={isLoading}
        >
          {isLoading ? 'Saving...' : 'Save'}
        </Button>
      </FormActionGroup>
    </Modal>
  );
}
export default AddShopifyStoreModal;
